import React from "react";
import PropTypes from 'prop-types';
import PartsTable from "../components/Tables/PartsTable";
import { withStyles } from '@material-ui/core/styles';
import { connect } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
import PartModal from '../components/Modals/PartModal';
import { loadParts } from '../actions/partActions';
import TableTop from '../components/Tables/TableSiteTop';
import { modalToggle } from '../actions/modalActions';
import { deletePart } from '../actions/partActions';
import { clearDeletePartsFailure } from '../actions/actionCreators';
import compose from 'recompose/compose';
import  SnackbarMessage  from '../components/Layout/SnackbarMessage';
import { addPartsSearchCriteria } from '../actions/searchActions';

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: 8,
    margin: 8
  },
  progress: {
    margin: theme.spacing.unit * 2,
  }

});

class PartsPage extends React.Component {
  componentDidMount() {
    this.props.loadParts();
  }


  state = {
    isModalOpen: false,
    useEditModal: false,
    // When clicking a table row, the row is hilighted and modal opened.
    // This property is used for removing the hilight when modal is closed.
    useSelectedRow: true,
    selectedPart: null
    }

  handleModalOpen = () => {
    this.setState({ isModalOpen: true });
    this.props.modalToggle(true);
  };

  handleCreateModalClose = () => {
    this.setState({ isModalOpen: false, useEditModal: false, useSelectedRow: false, selectedPart: null });
    this.props.modalToggle(false);
  };

  handleRowClick = (part) => {
    if (this.props.isDeleting ) {
      return;
    }
    this.props.modalToggle(true);
    this.setState({isModalOpen: true, useEditModal: true, useSelectedRow: true, selectedPart: part});
  }

  handlePartDelete = async (part) => {
    if (this.props.isDeleting ) {
      return;
    }
    this.setState({ useSelectedRow: true, selectedPart: part});
    let ans = window.confirm("Are you sure you want to delete this part?");
    if(ans) {
      await this.props.deletePart(part);
    }
    this.setState({ useSelectedRow: false, selectedPart: null});
  }

  handleSearchFieldChange = (searchCriteria) => {
    this.props.addPartsSearchCriteria(searchCriteria);
  }

  render() {
    const { classes, parts, role } = this.props;
    const { isModalOpen,  useEditModal, useSelectedRow, selectedPart } = this.state;
    const { handleModalOpen, handleCreateModalClose } = this;

    return (
      <div className={classes.root}>
        <TableTop role={role} roleOverride={true} isButtonDisabled={(parts.isLoading || parts.hasErrored)} handleModalOpen={handleModalOpen} headlineText="Parts"/>
        {parts.hasErrored && (
        <p>Error</p>
      )}
      {(parts.isLoading) && (
        <div>
          <CircularProgress className={classes.progress} size={50} />
        </div>
      )}
      {parts.partsData != null && parts.partsData.length > 0 && (
        <PartsTable
          role={role}
          handlePartDelete={this.handlePartDelete}
          useSelectedRow={useSelectedRow}
          handleRowClick={this.handleRowClick}
          parts={parts.partsData}
          handleSearchFieldChange={this.handleSearchFieldChange}
          searchFieldValues={this.props.searchFieldValues.parts}
          />
      )}
      <PartModal selectedPart={selectedPart} isEdit={useEditModal} isOpen={isModalOpen} handleClose={handleCreateModalClose}/>
      <SnackbarMessage />
    </div>
    )
  }
}

PartsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
      parts: state.part.parts,
      isDeleting: state.part.parts.isDeleting,
      deleteHasFailed: state.part.parts.deleteHasFailed,
      role: (state.oidc.user && state.oidc.user.profile) ? state.oidc.user.profile.identity_role : null,
      searchFieldValues: state.searchField
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadParts: () => {
      dispatch(loadParts())
    },
    modalToggle: (value) => {
      dispatch(modalToggle(value));
    },
    deletePart: (part) => {
      dispatch(deletePart(part))
    },
    clearDeletePartsFailure: () => {
      dispatch(clearDeletePartsFailure())
    },
    addPartsSearchCriteria: (searchField) => {
      dispatch(addPartsSearchCriteria(searchField))
    }
  }
}

export default
  compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
  )(PartsPage);



// WEBPACK FOOTER //
// ./src/containers/PartsPage.js